import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  HostBinding,
  Input,
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges,
} from '@angular/core';

@Component({
  selector: 'app-grid-skeleton',
  templateUrl: './grid-skeleton.component.html',
  styleUrls: ['./grid-skeleton.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class GridSkeletonComponent implements OnInit, OnChanges, OnDestroy {
  private resizeObserver: ResizeObserver;

  @Input()
  headerHeight = 40;

  @Input()
  rowHeight = 52;

  @Input()
  numberOfRows: number;

  @HostBinding('class.auto-rows')
  @Input()
  autoRows: boolean;

  @Input({ required: true })
  numberOfColumns: number;

  rows: void[];
  columns: void[];

  constructor(
    private readonly elementRef: ElementRef,
    private readonly cd: ChangeDetectorRef,
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if ('numberOfRows' in changes) {
      this.rows = [...Array(this.numberOfRows)];
    }

    if ('numberOfColumns' in changes) {
      this.columns = [...Array(this.numberOfColumns)];
    }
  }

  ngOnInit(): void {
    if (this.autoRows) {
      this.initializeResizeListener();
    }
  }

  ngOnDestroy(): void {
    this.resizeObserver?.disconnect();
  }

  private initializeResizeListener(): void {
    this.resizeObserver = new ResizeObserver(() => {
      const parentElement = this.elementRef.nativeElement.parentElement as HTMLElement;
      const availableHeight = parentElement.offsetHeight;
      const numberOfRows = Math.ceil((availableHeight - this.headerHeight) / this.rowHeight);

      this.rows = [...Array(numberOfRows)];
      this.cd.detectChanges();
    });

    this.resizeObserver.observe(this.elementRef.nativeElement.parentElement);
  }
}
